export const testDataMenuI18n = {
  testData: '生成测试数据',
  testDataPage: {
    title: '生成测试数据',
    description:
      '每个区块对应一个模块集群。创建前会检查已有数据（编码、名称），仅补充缺失项——生成数据接近真实业务数据。',
    skipExistingBadge: '自动跳过已存在记录',
    sectionBundle: '快速生成',
    sectionNhomHang: '货品分组',
    sectionHangHoa: '货品',
    sectionKho: '仓库',
    sectionCustomer: '客户',
    sectionSupplier: '供应商',
    btnBundleAll: '基础套装（{dm} 分组 + {nkh} 客户目录 + {ncc} 供应商）',
    btnDmNhomHang: '货品目录（{total}）',
    btnHangHoa: '货品（{perCat}/目录 × {cats} 叶级）',
    btnThuongHieu: '品牌（{count}）',
    btnDonViTinh: '计量单位（{count}）',
    btnViTri: '库位（{count}）',
    btnDmKhachHang: '客户目录（{count}）',
    btnKhachHang: '客户（{per}/目录）',
    btnDmNcc: '供应商目录（{count}）',
    btnNcc: '供应商（{count}）',
    seedAll: '基础套装：{dm} 个一级分组 + {nkh} 客户组 + {ncc} 供应商',
    seedAllHint: '按顺序执行 3 步；跳过已存在项。',
    seedNhomHangDanhMuc: '货品分组仅 1 级 — {count} 个根目录（无子级）',
    seedNhomHangTree3: '货品树 3 级 — {total} 个行业分组',
    seedNhomHangTree3Hint: '真实行业名称；可重复运行。',
    seedSanPham: '按目录生成货品 — 每目录 {perCat} 个 × {cats} 目录（共 {total} 个）',
    seedSanPhamHint: '需先有 3 级树；创建前检查货品编码。',
    seedThuongHieu: '品牌 — {count} 个（常见名称）',
    seedDonViTinh: '计量单位 — {count} 个（零售常用）',
    seedViTri: '库位 — {count} 个（10 区 × 10 货架）',
    seedViTriHint: '编码 VT-A01 … VT-J10。',
    seedNhomHangTree: '货品树 4 级 — 大量数据（{total} 个分组，较慢）',
    seedNhomKhachHang: '客户分组 — {count} 个细分',
    seedNhomKhachHangHint: '生成客户前先创建分组。',
    seedKhachHang: '按组生成客户 — 每组 {perGroup} × {groups} 组（共 {total}）',
    seedKhachHangHint: '姓名、电话、邮箱接近真实；关联正确分组。',
    seedNhaCungCap: '供应商 — {total} 家（真实公司名与编码）',
    seedNhaCungCapHint: '真实公司名与供应商编码。',
    progress: '{done} / {total}',
    logTitle: '结果',
    success: '完成 — 详见下方日志',
    failed: '创建测试数据失败',
    partialSuccess: '部分操作失败，请查看下方日志',
  },
} as const
